import type { HotkeyKeyValuePair } from '@/types'

export const shuffleHotKeys = (items: Array<HotkeyKeyValuePair>, noShuffleLast = 1): Array<HotkeyKeyValuePair> => {
  // Fisher–Yates shuffle algorithm for all elements except last x
  for (let i = items.length - (noShuffleLast + 1); i > 0; i--) {
    const j = Math.floor(Math.random() * i)
    const temp = items[i]
    items[i] = items[j]
    items[j] = temp
  }

  return items
}
